import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_USER} from "../../queries/users";

const UserPropertiesPanel = (props) => {

  let elements = null;
  if (!props.userId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "userId", label: "Id", type: "string"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "name", label: "Name", type: "string"},
      {prop: "email", label: "Email", type: "string"},
      {prop: "auth0.emailVerified", label: "Email Verified", type: "string"},
      {prop: "auth0.loginsCount", label: "Nr Logins", type: "number"},
      {prop: "auth0.lastIp", label: "Last IP", type: "string"},
      {prop: "auth0.lastLogin", label: "Last Login", type: "utc"},
      {prop: "auth0.lastPasswordReset", label: "Last Password Reset", type: "utc"},
      {prop: "auth0.updatedAt", label: "Updated", type: "utc"},
      {prop: "auth0.createdAt", label: "Created", type: "utc"},
    ])
    let variables = {userId: props.userId}
    elements = (
      <Query query={GET_USER} variables={variables} skip={!props.userId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.user)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="User" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default UserPropertiesPanel;